import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-uw-bg-primary via-uw-bg-secondary to-uw-bg-tertiary p-6">
      <div className="text-center max-w-2xl">
        <div className="mb-8 flex justify-center">
          {/* Perspective wrapper so rotateY looks like a real book */}
          <div className="book-3d">
            <svg
              width="320"
              height="220"
              viewBox="0 0 300 200"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="drop-shadow-2xl"
            >
              {/* Book Base */}
              <g>
                {/* Book Shadow */}
                <ellipse cx="150" cy="168" rx="120" ry="10" fill="url(#shadowGrad)" opacity="0.25" />

                {/* Right Page (static, the page we flip FROM) */}
                <path
                  d="M 160 40 L 240 40 Q 250 40 250 50 L 250 150 Q 250 160 240 160 L 160 160 Z"
                  fill="url(#rightPageGradient)"
                  stroke="#94a3b8"
                  strokeWidth="2"
                />

                {/* Book Spine */}
                <rect
                  x="140"
                  y="40"
                  width="20"
                  height="120"
                  fill="url(#spineGradient)"
                  stroke="#64748b"
                  strokeWidth="2"
                />

                {/* Turning Pages (right -> left). We stagger 3 for depth */}
                <g
                  className="page page--1"
                  style={{ transformOrigin: '160px 100px' }}
                >
                  <path
                    d="M 160 40 L 240 40 Q 250 40 250 50 L 250 150 Q 250 160 240 160 L 160 160 Z"
                    fill="url(#turnFront)"
                    stroke="#cbd5e1"
                    strokeWidth="1.5"
                  />
                </g>

                <g
                  className="page page--2"
                  style={{ transformOrigin: '160px 100px' }}
                >
                  <path
                    d="M 160 44 L 236 44 Q 246 44 246 54 L 246 146 Q 246 156 236 156 L 160 156 Z"
                    fill="url(#turnFront2)"
                    stroke="#dde3ea"
                    strokeWidth="1.3"
                  />
                </g>

                <g
                  className="page page--3"
                  style={{ transformOrigin: '160px 100px' }}
                >
                  <path
                    d="M 160 48 L 232 48 Q 242 48 242 58 L 242 142 Q 242 152 232 152 L 160 152 Z"
                    fill="url(#turnFront3)"
                    stroke="#e6ecf3"
                    strokeWidth="1.1"
                  />
                </g>

                {/* Left Page (static, we place it LAST so flipping pages tuck under) */}
                <path
                  d="M 50 50 Q 50 40 60 40 L 140 40 L 140 160 L 60 160 Q 50 160 50 150 Z"
                  fill="url(#leftPageGradient)"
                  stroke="#94a3b8"
                  strokeWidth="2"
                />

                {/* Page Lines (left) */}
                <line x1="70" y1="60" x2="120" y2="60" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="70" y1="75" x2="130" y2="75" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="70" y1="90" x2="125" y2="90" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="70" y1="105" x2="130" y2="105" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="70" y1="120" x2="120" y2="120" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="70" y1="135" x2="128" y2="135" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />

                {/* Page Lines (right) */}
                <line x1="170" y1="60" x2="230" y2="60" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="170" y1="75" x2="225" y2="75" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="170" y1="90" x2="235" y2="90" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="170" y1="105" x2="228" y2="105" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="170" y1="120" x2="233" y2="120" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
                <line x1="170" y1="135" x2="227" y2="135" stroke="#cbd5e1" strokeWidth="1.5" opacity="0.5" />
              </g>

              {/* Gradients */}
              <defs>
                <linearGradient id="leftPageGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#f8fafc" />
                  <stop offset="100%" stopColor="#e2e8f0" />
                </linearGradient>
                <linearGradient id="rightPageGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#e2e8f0" />
                  <stop offset="100%" stopColor="#f8fafc" />
                </linearGradient>
                <linearGradient id="spineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#64748b" />
                  <stop offset="50%" stopColor="#475569" />
                  <stop offset="100%" stopColor="#64748b" />
                </linearGradient>

                {/* Slight shadow under book */}
                <linearGradient id="shadowGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#000" stopOpacity="0.35" />
                  <stop offset="100%" stopColor="#000" stopOpacity="0" />
                </linearGradient>

                {/* Turning page front fills with subtle edge highlight */}
                <linearGradient id="turnFront" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#ffffff" />
                  <stop offset="85%" stopColor="#eef2f7" />
                  <stop offset="100%" stopColor="#d9e1ea" />
                </linearGradient>
                <linearGradient id="turnFront2" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#ffffff" />
                  <stop offset="85%" stopColor="#f3f6fa" />
                  <stop offset="100%" stopColor="#e6edf5" />
                </linearGradient>
                <linearGradient id="turnFront3" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#ffffff" />
                  <stop offset="85%" stopColor="#f7f9fc" />
                  <stop offset="100%" stopColor="#edf2f9" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>

        <div className="space-y-6">
          <div className="space-y-2">
            <h1 className="text-7xl font-bold bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 bg-clip-text text-transparent animate-fade-in">
              404
            </h1>
            <h2 className="text-3xl font-semibold text-uw-text-primary animate-fade-in" style={{ animationDelay: '0.1s' }}>
              Page Not Found
            </h2>
          </div>

          <p className="text-lg text-uw-text-secondary max-w-md mx-auto animate-fade-in" style={{ animationDelay: '0.2s' }}>
            The page you're looking for seems to have been lost in the story. Let's get you back on track.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <Link
              to="/ai"
              className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              Go Home
            </Link>

            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center px-6 py-3 bg-uw-surface-elevated text-uw-text-primary font-semibold rounded-xl border-2 border-uw-border-default hover:border-uw-border-strong hover:bg-uw-surface-overlay transition-all"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Go Back
            </button>
          </div>
        </div>
      </div>

      <style>{`
        /* Make 3D transforms on SVG believable */
        .book-3d { perspective: 1200px; }
        .book-3d svg { transform-style: preserve-3d; }

        /* Critical for SVG: use the SVG viewBox coordinate system for origin */
        .page {
          transform-box: view-box;
          will-change: transform, filter, opacity;
          backface-visibility: hidden;
          filter: drop-shadow(0 4px 10px rgba(0,0,0,0.25));
          pointer-events: none;
          animation: page-flip-rtl 2.8s ease-in-out infinite;
        }
        .page--2 { animation-delay: 0.35s; opacity: 0.9; }
        .page--3 { animation-delay: 0.7s;  opacity: 0.8; }

        @keyframes page-flip-rtl {
          /* Start flat on right page */
          0%   { transform: rotateY(0deg);   opacity: 1; }
          10%  { transform: rotateY(-10deg); }
          45%  { transform: rotateY(-120deg); }
          50%  { transform: rotateY(-178deg); opacity: 0.92; }
          /* Land just past flat on the left, then reset on loop (looks like next page) */
          60%  { transform: rotateY(-180deg); opacity: 0.95; }
          100% { transform: rotateY(-180deg); opacity: 0.95; }
        }
      `}</style>
    </div>
  );
}
